import { render } from "./trust-data-banks.html?vue&type=template&id=9450af10&scoped=true&ts=true&external"
import script from "./trust-data-banks.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-banks.ts?vue&type=script&lang=ts&external"

import "./trust-data-banks.scss?vue&type=style&index=0&id=9450af10&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9450af10"]])

export default __exports__